import { isServer } from "utils/env";
import * as queryUtils from "utils/query";
import history from "../history";

export const isAbsoluteUrl = (url) => {
  return /^([a-z][a-z0-9+.-]*:)?\/\//.test(url);
};

export const redirect = (url) => {
  if (isServer()) {
    console.warn("redirection on server not implemented yet");
    return;
  }
  if (url) {
    window.location = url;
  }
};

export const getSearchParam = (name) => {
  const queryParams = new URLSearchParams(history.location.search);

  return queryParams.get(name);
};

export const hasSearchParam = (name) => {
  const queryParams = new URLSearchParams(history.location.search);

  return queryParams.has(name);
};

/**
 *  deletes the query params of the given name(s)
 *
 * @param {string, array} names
 */
export const deleteSearchParams = (names) => {
  let queryParams = queryUtils.fromQuery(history.location.search);

  if (Array.isArray(names)) {
    names.forEach((name) => delete queryParams[name]);
  }
  if (typeof names === "string" || names instanceof String) {
    delete queryParams[names];
  }

  history.replace({
    path: location.pathname,
    search: queryUtils.toQuery(queryParams),
  });
};

// The export needs to be done taht way for our current test env to mock the function
export const UrlUtils = { redirect };
